<template>
    <v-dialog v-model="dialog" width="420px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" small icon class="mx-2" color="secondary">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>delete</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="justify-center subtitle-2 pt-6 text-pre-wrap">
                Do you really want to delete the user with name <span class="px-2 secondary--text"> {{ user.name }} </span> ?
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    No
                </v-btn>
                <v-btn color="error" text class="text-capitalize" :disabled="Boolean(error)" @click="deleteUser">
                    Yes</v-btn>
            </v-card-actions>
        </v-card>
        <div v-else class="text-xs-center">
            <loader></loader>
        </div>
    </v-dialog>
</template>

<script>
import Loader from '../../../layouts/Loader.vue'

export default {
    props: ['user'],
    data() {
        return {
            dialog: false,
            error: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        currentUser() {
            return this.$store.getters.user;
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        async deleteUser() {
            if (this.user && this.user.id) {
                const id = this.user.id
    
                try {
                    await this.$store.dispatch('deleteUser', id);
                    if (this.currentUser.id == id) {
                        await this.$store.dispatch('logout', id);
                    }
                }
                catch (error) {
                    console.log(error.message)
                }
            }
        }
    },
    components: { Loader }
}
</script>